import React from 'react';

import FormError from 'src/core/gd-form/common/form-error/form-error.tsx';
import ButtonSubmit from 'core/gd-form/common/btn-submit/btn-submit';
import Input from 'core/gd-form/form-element/input/input.jsx';
import Textarea from "core/gd-form/form-element/textarea/textarea";
import Toggle from 'src/core/gd-form/form-element/toggle-new/toggle';


class SettingsFormProto extends React.Component {

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);

        this.field = this.props.field;

        this.initFormData = {
            name: this.field.label,
            description: this.field.description,
            isRequired: this.field.isRequired
        };


        this.formStructure = {
            fields: {
                name: {
                    type: 'input',
                    isRequired: true,
                    label: 'Name',
                    validator: (val) => {
                        let res = true;
                        if (val === null || val === undefined || val.trim() === '') {
                            res = 'No valid characters found';
                        }
                        return res;
                    }
                },
                description: {
                    type: 'input',
                    isRequired: false,
                    label: 'Description'
                },
                isRequired: {
                    type: 'boolean',
                    isRequired: false,
                    label: 'Is required'
                },
            },
            onSubmit: this.onSubmit
        };

        // this.form = new FormManager(formStructure, initFormData); that should happen in field!
    }

    onSubmit(result) {
        console.error("This method should be ovveridden");
    }

    renderDescription() {
        return (
            <div className="row cf">
                <div className="label">Description</div>
                <div className="element">
                    <Textarea className="field-description"
                              size="big"
                              rows={2}
                              form={this.form}
                              name="description" />
                </div>
                <div className="cf"/>
                <FormError form={this.form} name="description"/>
            </div>
        )
    }

    renderName() {
        return (
            <div className="row cf">
                <div className="label">Name</div>
                <div className="element">
                    <Input size="big" form={this.form} name="name"/>
                </div>
                <div className="cf" />
                <FormError form={this.form} name="name" />
            </div>
        )
    }

    renderType() {
        return (
            <div className="row cf">
                <div className="label">Type</div>
                <div className="element type-name">
                    {gd.const.formFields[this.props.field.type].label}
                </div>
                <div className="cf" />
            </div>
        )
    }

    renderIsRequired() {
        return (
            <div className="row cf">
                <div className="label">Is required</div>
                <div className="element type-name">
                    <Toggle size="20" form={this.form} name="isRequired" />
                </div>
                <div className="cf" />
            </div>
        )
    }

    render() {
        return (
            <div className="form-container">
                {this.renderForm()}
                <div className="modal-submit">
                    <ButtonSubmit form={this.form} className="submit" label="Submit" />
                </div>
            </div>
        );
    }

    renderForm() {
        console.error("Should be ovveriddedn");
    }
}

module.exports = SettingsFormProto;